const CookieConsent = require('@klaxit/cookie-consent').default;

$(function () {
    var acceptedCategories = [];
    const scripts = [];

    $('script[type="javascript/blocked"]').each((i, el) => {
        const jel = $(el);
        scripts.push(jel);
        jel.remove();
    })

    var dataLayer = window.dataLayer = window.dataLayer || [];

    function gtag() {
        dataLayer.push(arguments);
    }

    gtag('consent', 'default', {
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'analytics_storage': 'denied'
    });

    const cc = new CookieConsent(cl);

    const sendCookiesTags = function (categories) {
        if (categories.indexOf('marketing') === -1) {
            gtag('consent', 'update', {
                'ad_storage': 'denied',
                'ad_user_data': 'denied',
                'ad_personalization': 'denied',
                'analytics_storage': 'denied'
            });
        }
        if (categories.length === 0) return;
        acceptedCategories = categories;
        for (const category of categories) {
            if (category === 'necessary') continue;

            if (category === 'marketing') {
                gtag('consent', 'update', {
                    'ad_storage': 'granted',
                    'ad_user_data': 'granted',
                    'ad_personalization': 'granted',
                    'analytics_storage': 'granted'
                });
            }

            dataLayer.push({
                'eventCategory': category,
                'event': 'EventeeCookiesEvent'
            });
            for (const script of scripts) {
                if (script.attr('title') === category) {
                    script.attr('type', 'application/javascript');
                    script.appendTo('head');
                }
            }
        }
        window.postMessage({
            method: 'cookiesAccepted',
            categories: categories
        }, '*');
    }

    sendCookiesTags(cc.acceptedCategories);

    cc.on('change', (cc) => {
        sendCookiesTags(cc.acceptedCategories);
    });

    window.reopenCookies = function () {
        cc.open();
    }

    window.hasAcceptedCookieCategory = function (category) {
        for (const acceptedCategory of acceptedCategories) {
            if (category === acceptedCategory) {
                return true;
            }
        }
        return false;
    }
});
